
import { useStaticQuery, graphql } from "gatsby"

const GetProjectsImgs = () => {
  const data = useStaticQuery(graphql`
  query{
    allDatoCmsProject{
        nodes{   
            id
            title
            description
            imgprincipal{
                fluid(maxWidth:1200){
                    ...GatsbyDatoCmsFluid
                }
            }
        }
    }
}
  `)


  return  data.allDatoCmsProject.nodes.map(project=>({
    id:project.id,
    title:project.title,
    description:project.description,
    img:project.imgprincipal
}))
}


export default GetProjectsImgs